// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","user":"styles_user__-VUAz","field":"styles_field__avwYc","content":"styles_content__q0QL3","icon":"styles_icon__LNrVp"};